<template>
  <div class="send-sendpackge">
    <!--    <p class="desc">Send information</p>-->
    <div class="form">
      <p class="form-title">Ship from</p>
      <InputWrap class="row shipper" size="large">
        <i-input v-model="firstname" class="shipper-name" size="large" placeholder="First Name" />
        <i-input v-model="lastname" class="shipper-name" size="large" placeholder="Last Name" />
      </InputWrap>
      <InputWrap class="row shipping-address" size="large">
        <i-input ref="shipaddress" v-model="sendAddr1" class="street" size="large" placeholder="Street address" />
        <i-input
          v-model="sendAddr2"
          class="floor"
          size="large"
          placeholder="Apt / Unit / Floor / Suite etc.(optional)"
        />
      </InputWrap>
      <InputWrap class="row" size="large">
        <div class="sp-wrap">
          <i-input v-model="sendCountry" class="country" disabled size="large" />
          <i-select
            v-model="state"
            filterable
            class="state"
            not-found-text=""
            remote
            :loading="stateLoading"
            size="large"
          >
            <i-option v-for="iState in states" :key="iState.key" :value="iState.key">{{ iState.value }}</i-option>
          </i-select>
          <i-input v-model="sendCity" class="city" size="large" placeholder="City" />
        </div>
      </InputWrap>
      <InputWrap class="row" size="large">
        <div class="sp-wrap">
          <i-input v-model="zipcode" class="zip-code" size="large" placeholder="Zipcode" />
          <i-input v-model="sendMobile" class="phone-number" size="large" placeholder="Phone" />
        </div>
      </InputWrap>
    </div>
    <div class="boxes">
      <p class="boxes-title">Shipping Insurance</p>
      <p class="boxes-desc">
        By creating shipment, you agree to our
        <a href="https://support.movingkite.com/hc/en-us/articles/5926592731419-Terms-of-Insurance" target="_blank">
          Terms of Shipping Insurance
        </a>
      </p>
      <ul class="box-list">
        <li v-for="(box, index) in boxes" :key="index | numer">
          <InputWrap size="large" class="box-item" :label="index | numer">
            <i-select
              :value="box.insurance"
              not-found-text=""
              remote
              :loading="insuranceLoading"
              size="large"
              @on-select="selectInsurance($event, index)"
            >
              <i-option
                v-for="insurance in insurances"
                :key="insurance.insurance"
                :value="insurance.insurance"
                :desc="insurance.desc"
                >{{ insurance.desc }}
              </i-option>
            </i-select>
            <span v-show="index !== 0" slot="right" class="remove" @click="removeBoxes(index)">Remove</span>
          </InputWrap>
        </li>
      </ul>
      <Button class="add-boxes" size="large" type="outline" @click.native="addBoxes">
        <span>+ Add</span>
      </Button>
      <!--      新内容-->
      <div class="coverage-box">
        <p style="margin-top: 36px">
          <span class="title">Storage insurance plan</span>
          <br />
          <span class="desc">
            By creating shipment, you agree to our
            <a
              href="https://support.movingkite.com/hc/en-us/articles/24874450158619-Limited-Security-Warranty-Policy"
              target="_blank"
            >
              Terms of Storage Insurance
            </a>
          </span>
        </p>
        <div>
          <div class="card" :class="{ active: isBasic }" style="margin-top: 20px" @click="chooseBasic">
            <p class="card-right">
              <span class="card-right-title">Basic</span>
              <br />
              <span class="card-right-desc">Every package is automatically covered up to $100</span>
            </p>
            <span class="card-left">Free</span>
          </div>
          <div ref="downloadRef">
            <div class="card" :class="{ active: !isBasic }" style="margin-top: 16px" @click="openCoverageList">
              <p class="card-right">
                <span class="card-right-title">Plus</span>
                <br />
                <span class="card-right-desc">{{ coverageType }}</span>
              </p>
              <i-tool-tip v-show="charge != 0">
                <div slot="content">
                  {{ price }} <span class="star"> * </span> 7 Days <span class="star"> * </span>
                  {{ boxes.length }} Packages
                </div>
                <div class="card-left">${{ charge }}/week</div>
              </i-tool-tip>
            </div>
            <transition name="dropdown">
              <ul v-if="openItem" class="download-item-list">
                <template v-for="(item, index) in coverageItemList">
                  <li :key="index" class="download-item" @click="chooseCoverageType(item)">{{ item }}</li>
                </template>
              </ul>
            </transition>
          </div>
        </div>
      </div>

      <div class="packge">
        <p class="title">How to ship your package?</p>
        <ul class="type-list">
          <li class="type-item" :class="{ active: pickup }" @click="slectPickUp">
            <div class="type-left">
              <p class="type-img-box">
                <img src="../../../assets/imgs/home-form-car.png" />
              </p>
              <div>
                <p class="type-title">Pick up</p>
                <div class="type-desc-left">
                  <label>${{ pickUpPrice }}</label>
                  <span> / times</span>
                </div>
              </div>
            </div>
            <div class="type-right">
              <p class="type-desc">
                <a href="https://support.movingkite.com/hc/en-us/articles/4404707626779" target="_blank">
                  Learn more about FedEx pick up
                </a>
              </p>
            </div>
          </li>
          <li class="type-item" :class="{ active: !pickup }" @click="selectDropOf">
            <div class="type-left">
              <p class="type-img-box">
                <img src="../../../assets/imgs/home-form-house.png" />
              </p>
              <div>
                <p class="type-title">Drop off</p>
                <span class="type-desc-left">Free</span>
              </div>
            </div>
            <div class="type-right">
              <p class="type-desc" @click="window.open('https://local.fedex.com/en-us', '_blank')">
                <a href="https://local.fedex.com/en-us" target="_blank"> Find FedEx locations nearby </a>
              </p>
            </div>
          </li>
        </ul>
        <div v-if="pickup" class="type-pickup">
          <p class="type-pickup-title">Schedule FedEx pick up</p>
          <div v-if="pickupTimerangeLoading" class="loading-wrap">
            <i-spin>
              <i-icon type="ios-loading" size="40" class="spin-icon-load" />
            </i-spin>
          </div>
          <template v-else>
            <p v-if="pickupTimerangeError" class="type-pickup-error">
              Please enter the shipping zip code first, and you can select a valid pick-up time
            </p>
            <template v-else>
              <p class="type-pickup-desc">
                <img src="../../../assets/imgs/warning.png" />
                <span>
                  FedEx only accepts appointments on business days within two weeks from now. You can make an
                  appointment from <span class="date-span">{{ pickupDate[0] }}</span> to
                  <span class="date-span">{{ pickupDate[pickupDate.length - 1] }}</span
                  >.
                </span>
              </p>
              <div class="earliest-time">
                <InputWrap class="date" label="Pickup date" size="large">
                  <i-date-picker
                    :value="pickupDatePrefix"
                    :options="pickOptions"
                    size="large"
                    format="MM/dd/yy"
                    placeholder="mm/dd/yy"
                    @on-change="pickupDatePrefixChange"
                  />
                </InputWrap>
                <InputWrap class="time" label="Ready time" size="large">
                  <i-select
                    v-if="selectDateToday"
                    v-model="selectPickupTime"
                    not-found-text=""
                    remote
                    :loading="insuranceLoading"
                    size="large"
                    @on-change="selectPickupTimeChange"
                  >
                    <i-option v-for="time in pickupTimeToday" :key="time" :value="time">{{ time }}</i-option>
                  </i-select>
                  <i-select
                    v-else
                    v-model="selectPickupTime"
                    not-found-text=""
                    remote
                    :loading="insuranceLoading"
                    size="large"
                    @on-change="selectPickupTimeChange"
                  >
                    <i-option v-for="time in pickupTime" :key="time" :value="time">{{ time }}</i-option>
                  </i-select>
                </InputWrap>
                <InputWrap class="time" label="Latest time" size="large">
                  <i-select
                    v-if="selectDateToday"
                    v-model="selectCutoffTime"
                    not-found-text=""
                    remote
                    :loading="insuranceLoading"
                    size="large"
                  >
                    <template v-for="(time, index) in cutoffTimeToday">
                      <i-option v-if="index >= pickUpIndex" :key="time" :value="time">{{ time }}</i-option>
                    </template>
                  </i-select>
                  <i-select
                    v-else
                    v-model="selectCutoffTime"
                    not-found-text=""
                    remote
                    :loading="insuranceLoading"
                    size="large"
                  >
                    <template v-for="(time, index) in cutoffTime">
                      <i-option v-if="index >= pickUpIndex" :key="time" :value="time">{{ time }}</i-option>
                    </template>
                  </i-select>
                </InputWrap>
              </div>
            </template>
          </template>
        </div>
      </div>
      <div class="info-footer">
        <Button class="btn" @click="saveOrder">Create Order</Button>
      </div>
      <i-dialog
        v-model="saveLoding"
        :closable="false"
        :mask-closable="false"
        footer-hide
        :class-name="'vertical-center-modal'"
      >
        <div class="save-loading-dialog">
          <i-icon style="text-align: center" :size="60" type="ios-loading" color="#6E6DEF" class="spin-icon-load" />
          <p>The package shipping label is being created.</p>
          <p>Please be patient.</p>
        </div>
      </i-dialog>
    </div>
  </div>
</template>

<script>
import InputWrap from '../../../components/input/InputWrap';
import Button from '../../../components/button/Button';
import moment from 'moment';
import { mapState, mapActions, mapMutations } from 'vuex';
import jsLoader from '../../../utils/jsLoader';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { API } from '@/net/http';
import { storageInsuranceValueToStr } from '../../../utils/StorageInsurance';

export default {
  components: {
    InputWrap,
    Button,
  },
  data() {
    return {
      boxes: [],
      states: [],
      insuranceLoading: true,
      warehouseName: '',
      houseId: '',
      zipcode: '',
      pickup: false,
      pickupLoading: true,
      pickUpPrice: '--',
      state: '',
      stateLoading: true,
      sendCity: '',
      firstname: '',
      lastname: '',
      sendAddr1: '',
      sendAddr2: '',
      sendMobile: '',
      saveLoding: false,
      sendCountry: 'US',
      pickupTimerangeLoading: true,
      pickupDate: [],
      cutoffTime: [],
      pickupTimeToday: [],
      cutoffTimeToday: [],
      selectCutoffTime: '',
      pickupTime: [],
      selectPickupTime: '',
      orderNum: null,
      pickOptions: {
        disabledDate: val => {
          let pk = moment(val).format('MM/DD/YYYY');
          return this.pickupDate.indexOf(pk) === -1;
        },
      },
      pickupDatePrefix: '',
      pickupTimerangeError: false,
      pickUpIndex: 0,

      coverageType: 'Choose how much coverage you need',
      openItem: false,
      isBasic: true,
      coverageItemList: [
        'Insure $0.1/package/day, every package is covered up to $200',
        'Insure $0.2/package/day, every package is covered up to $300',
        'Insure $0.3/package/day, every package is covered up to $400',
        'Insure $0.4/package/day, every package is covered up to $500',
        'Insure $0.5/package/day, every package is covered up to $600',
        'Insure $0.6/package/day, every package is covered up to $700',
        'Insure $0.65/package/day, every package is covered up to $750',
      ],
    };
  },
  created() {
    this.$bus.$on('clearSendPackge', () => {
      if (!this.$route.path.startsWith('/send')) {
        this.updateChange(false);
        Object.assign(this.$data, this.$options.data());
        this.clearLocaleOrder();
      }
    });
  },
  mounted() {
    let cacheDataObj = this.$store.state.home.formComponentData;
    if (cacheDataObj?.pickup) {
      this.pickup = cacheDataObj.pickup;
      this.pickupLoading = false;
      this.slectPickUp();
    } else {
      this.selectDropOf();
    }
    this.init();
    this.updateChange(false);
    document.addEventListener('click', e => {
      if (this.$refs.downloadRef) {
        let isSelf = this.$refs.downloadRef.contains(e.target);
        if (!isSelf) {
          this.openItem = false;
        }
      }
    });
    let { query } = this.$route;
    if (query.ordertype === 'draft' && this.sendInfo) {
      this.processSendInfo();
    }
  },
  beforeDestroy() {
    if (!this.isChange) {
      Object.assign(this.$data, this.$options.data());
      this.clearLocaleOrder();
    }
    window.removeEventListener('click', () => {}, true);
  },
  methods: {
    ...mapActions('calculate', ['search']),
    init() {
      this.initSearch();
      this.$nextTick(() => {
        jsLoader(
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyBZhHEG1ZINGM7scAC6fBpHP3CgVyh-jd0&libraries=places&v=weekly',
          'google',
        ).then(() => {
          this.$maps = window.google.maps;
          this.initAutoComplete();
        });
      });
    },
    pickupDatePrefixChange(date) {
      this.pickupDatePrefix = moment(date, 'MM/DD/YY').format('MM/DD/YY');
      this.pickUpIndex = 0;
      if (this.selectDateToday) {
        this.selectCutoffTime = this.cutoffTimeToday[0];
        this.selectPickupTime = this.pickupTimeToday[0];
      } else {
        this.selectCutoffTime = this.cutoffTime[0];
        this.selectPickupTime = this.pickupTime[0];
      }
    },
    initSearch() {
      let { query, params } = this.$route;
      if ((!query.name || !query.code) && !params['orderNumber'] === 'new') {
        delete query['select'];
        this.$router.replace({
          name: 'calculate',
          query: query,
        });
      }
      if (this.localeOrder) {
        let change = this.localeOrder['houseId'] !== query.houseId;
        let keys = Object.keys(this.localeOrder);
        keys.forEach(key => {
          this[key] = this.localeOrder[key];
        });
        if (this.pickup) {
          if (change) {
            this.pickupDatePrefix = '';
            this.selectPickupTime = '';
            this.selectCutoffTime = '';
          }
          this.initPickupTimeRange();
        }
      }
      this.initStates();
      this.initInsurance();
      this.initPickUp();
      this.setStoreOrder(null);
      //修改部分
      this.houseId = query.houseId;
      this.warehouseState = query.state;
    },
    processSendInfo() {
      this.$store.commit('home/updateChangeValue', false);
      this.$store.commit('home/updateSetCacheValue', false);
      let order = this.sendInfo;
      if (order.status === 'DRAFT') {
        this.sendAddr1 = order.sendAddr1;
        this.sendCity = order.sendCity;
        this.firstname = order.sendFirstName;
        this.lastname = order.sendLastName;
        this.zipcode = order.sendPostcode;
        this.state = order.sendState;
        this.sendMobile = order.sendMobile;
        this.boxes = order.insurances.map(item => {
          item.insurance = Number(item.insurance).toString();
          return item;
        });
        this.parseCoverageType(order.insuranceStorage);
        this.orderNum = order.orderNum;
        this.pickup = order.pickup;
        this.houseId = order.houseId;
        this.sendCountry = order.sendCountry;
        this.sendAddr2 = order.sendAddr2;
        this.pickupTime = order.pickupTime;
        this.cutoffTime = order.cutoffTime;
        this.sendAddr1 = order.sendAddr1;
        this.pickupDatePrefix = '';
        this.selectPickupTime = '';
        this.selectCutoffTime = '';
        if (this.pickup && this.zipcodeChecked) {
          this.initPickupTimeRange();
        }
      }
    },
    initStates() {
      this.stateLoading = true;
      this.getStates()
        .then(res => {
          this.stateLoading = false;
          if (res.success) {
            this.states = res.data;
          }
        })
        .catch(() => {
          this.stateLoading = false;
        });
    },
    initInsuranceBox() {
      let { query } = this.$route;
      if (query.count && /^\d+$/.test(query.count) && this.boxes.length === 0) {
        var boxes = new Array(Number(query.count));
        for (let i = 0; i < boxes.length; i++) {
          boxes[i] = {
            insurance: '0',
            desc: 'Not insured',
          };
        }
        this.boxes = boxes;
      }
    },
    initInsurance() {
      this.insuranceLoading = true;
      this.getInsurance()
        .then(() => {
          this.insuranceLoading = false;
          this.initInsuranceBox();
        })
        .catch(() => {
          setTimeout(() => {
            this.initInsurance();
          }, 1500);
        });
    },
    initPickUp() {
      this.getPickUpPrice()
        .then(res => {
          if (res.success) {
            this.pickUpPrice = res.data;
            this.pickupLoading = false;
          } else {
            setTimeout(() => {
              this.initPickUp();
            }, 1500);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.initPickUp();
          }, 1500);
        });
    },
    slectPickUp() {
      if (!this.pickupLoading) {
        this.pickupTimerangeLoading = false;
        this.pickupTimerangeError = false;
        this.pickup = true;
        if (this.zipcodeChecked) {
          this.initPickupTimeRange();
        } else {
          this.pickupTimerangeError = true;
        }
      }
    },
    initPickupTimeRange() {
      this.pickupTimerangeLoading = true;
      this.getPickUpTimeRange({
        postcode: this.zipcode,
        houseId: this.houseId,
      })
        .then(res => {
          this.pickupTimerangeLoading = false;
          if (res.success) {
            let { pickupDate, cutoffTimeFuture, pickupTimeFuture, pickupTimeToday, cutoffTimeToday } = res.data;
            this.pickupDate = pickupDate;
            this.cutoffTime = cutoffTimeFuture;
            this.pickupTime = pickupTimeFuture;
            this.pickupTimeToday = pickupTimeToday;
            this.cutoffTimeToday = cutoffTimeToday;
            this.pickupDatePrefix = moment(this.pickupDate[0], 'MM/DD/YYYY').format('MM/DD/YY');
            this.selectPickupTime = this.pickupTimeToday[0];
            this.selectCutoffTime = this.cutoffTimeToday[0];
            this.pickUpIndex = 0;
            this.pickOptions = {
              disabledDate: val => {
                let pk = moment(val).format('MM/DD/YYYY');
                return this.pickupDate.indexOf(pk) === -1;
              },
            };
          }
        })
        .then(() => {
          if (!this.sendInfo.pickupTime) return;
          //判断回显日期是否可用，可用则选择
          const pickupTime = moment(this.sendInfo.pickupTime, 'MM/DD/YYYY HH:mm:ss');
          if (pickupTime.isSame(moment(this.pickupDate[0]), 'day')) {
            //当天的pickup
            if (
              pickupTime.isSameOrAfter(moment(this.pickupDate[0] + ' ' + this.pickupTimeToday[0]), 'minute') &&
              pickupTime.isSameOrBefore(moment(this.pickupDate[0] + ' ' + this.pickupTimeToday.at(-1)), 'minute')
            ) {
              //时间在取件范围内
              this.selectPickupTime = pickupTime.format('HH:mm:ss');
              this.selectCutoffTime = moment(this.sendInfo.cutoffTime).format('HH:mm:ss');
            }
          } else {
            //非当天pickup
            const pIndex = this.pickupDate.findIndex(e => e === pickupTime.format('MM/DD/YYYY'));
            if (pIndex > -1) {
              //在可用pickup日期中，继续判断时间
              if (
                pickupTime.isSameOrAfter(moment(this.pickupDate[pIndex] + ' ' + this.pickupTime[0]), 'minute') &&
                pickupTime.isSameOrBefore(moment(this.pickupDate[pIndex] + ' ' + this.pickupTime.at(-1)), 'minute')
              ) {
                //时间在取件范围内
                this.pickupDatePrefix = moment(this.pickupDate[pIndex], 'MM/DD/YYYY').format('MM/DD/YY');
                this.selectPickupTime = pickupTime.format('HH:mm:ss');
                this.selectCutoffTime = moment(this.sendInfo.cutoffTime).format('HH:mm:ss');
              }
            }
          }
        })
        .catch(() => {
          this.pickupTimerangeLoading = false;
        });
    },
    selectPickupTimeChange(e) {
      let sindex = this.pickupTime.findIndex(c => c == e);
      if (sindex > -1 && this.cutoffTime[sindex]) {
        this.pickUpIndex = sindex;
        this.selectCutoffTime = this.cutoffTime[sindex];
      }
    },
    selectDropOf() {
      this.pickup = false;
    },
    addBoxes() {
      this.boxes.push({
        insurance: '0',
        desc: 'Not insured',
      });
    },
    removeBoxes(index) {
      this.boxes.splice(index, 1);
    },
    selectInsurance(row, index) {
      this.boxes[index].insurance = row.value;
      this.boxes[index].desc = row.label;
    },
    chooseBasic() {
      this.isBasic = true;
      this.coverageType = 'Choose how much coverage you need';
      this.openItem = false;
    },
    openCoverageList() {
      this.openItem = true;
    },
    // changeItem() {
    //   this.openItem = true;
    // },
    chooseCoverageType(it) {
      this.coverageType = it;
      this.openItem = false;
      this.isBasic = false;
    },
    parseCoverageType(storageInsurance) {
      if (storageInsurance === '0') {
        this.coverageType = 'Choose how much coverage you need';
        this.isBasic = true;
      } else {
        this.coverageType = storageInsuranceValueToStr[storageInsurance];
        this.isBasic = false;
      }
    },
    initAutoComplete() {
      let address1Field = this.$refs.shipaddress.$el.children[1];
      let autocomplete = new this.$maps.places.Autocomplete(address1Field, {
        types: ['address'],
        componentRestrictions: {
          country: ['us'],
        },
        fields: ['address_components', 'geometry'],
      });
      autocomplete.addListener('place_changed', () => {
        let place = autocomplete.getPlace();
        this.formarPlace2data(place);
      });
    },
    formarPlace2data(place) {
      let address1 = '',
        postcode = '',
        locality = '',
        state = '';
      for (const component of place.address_components) {
        const componentType = component.types[0];
        switch (componentType) {
          case 'street_number': {
            address1 = `${component.long_name} ${address1}`;
            break;
          }
          case 'route': {
            address1 += component.short_name;
            break;
          }
          case 'postal_code': {
            postcode = `${component.long_name}${postcode}`;
            break;
          }
          case 'postal_code_suffix': {
            postcode = `${postcode}-${component.long_name}`;
            break;
          }
          case 'locality': {
            locality = component.long_name;
            break;
          }
          case 'administrative_area_level_1': {
            state = component.short_name;
            break;
          }
          // case "country":
          //   country = component.short_name;
          //   break;
        }
      }
      this.state = state;
      this.sendCity = locality;
      // this.sendCountry = country;
      if (postcode) {
        this.zipcode = postcode;
      } else {
        this.zipcode = '';
      }
      this.sendAddr1 = `${address1}`;
    },
    async saveOrder() {
      if (this.saveLoding) return;
      if (!this.checkForm()) return;

      this.saveLoding = true;
      this.$emit('change-loading', true);

      let flag;
      let { query } = this.$route;
      const weight = query.weight || this.sendInfo.weightLb;

      //判断邮编地址等信息是否正确
      await this.$post(API.checkAddress, {
        houseId: this.houseId,
        sendState: this.state,
        sendCity: this.sendCity,
        sendAddr1: this.sendAddr1,
        sendAddr2: this.sendAddr2,
        sendPostcode: this.zipcode,
        count: query.count || this.boxes.length,
        weight: weight,
      }).then(res => {
        flag = res.success;
        if (!res.success) {
          this.saveLoding = false;
          this.$emit('change-loading', false);
          this.$Message.error({
            content: res.message,
            duration: 5,
          });
        }
      });

      //如果地址信息校验错误，不执行save
      if (!flag) return;

      let pickupTime = '',
        cutoffTime = '';
      if (this.pickup) {
        pickupTime = this.pickupDatePrefix + ' ' + this.selectPickupTime;
        cutoffTime = this.pickupDatePrefix + ' ' + this.selectCutoffTime;
      }
      let body = {
        sendAddr1: this.sendAddr1,
        sendCity: this.sendCity,
        sendFirstName: this.firstname,
        sendLastName: this.lastname,
        sendPostcode: this.zipcode,
        sendState: this.state,
        sendMobile: this.sendMobile,
        insurances: this.boxes,
        weightLb: weight,
        orderNum: this.orderNum,
        pickup: this.pickup,
        houseId: this.houseId,
        sendCountry: this.sendCountry,
        sendAddr2: this.sendAddr2,
        pickupTime: pickupTime,
        cutoffTime: cutoffTime,
        insuranceStorage: this.price,
      };
      await this.saveOrder2serverAndLocle(body)
        .then(res => {
          if (res.data) {
            this.setOrder(res.data);
          }

          if (res.success) {
            this.setStoreOrder(null);
            this.$Message.success('success');
            this.$router.replace(`/send/${res.data.orderNum}`);
            this.$emit('change-route', 'prepayment');
            return;
          }

          //异常处理
          if (res.response && (res.response.status === 401 || res.response.status === 403)) {
            this.$emit('change-route', 'login');
          } else if (
            res.code === 'kite.common.order.need-verify' ||
            res.code === 'kite.common.order.need-input-email'
          ) {
            this.$emit('change-route', 'bindemail');
            this.setStoreOrder(null);
            this.$router.replace(`/send/${res.data.orderNum}?ordertype=draft`);
          } else if (res.code === 'kite.common.order.need-bind') {
            this.setStoreOrder(null);
            this.$emit('change-route', 'prepayment');
            this.$router.replace(`/send/${res.data.orderNum}?ordertype=draft`);
          } else if (res.code === 'kite.common.fedex.ship.failed') {
            this.setStoreOrder(null);
            this.$router.replace(`/send/${res.data.orderNum}?ordertype=draft`);
            this.$emit('change-route', 'boxstatus');
          } else {
            this.$Modal.error({
              content:
                '<p style="font-family: Montserrat-Regular; font-size: 16px; font-weight: 400;' +
                '  color: #262626; line-height: 25px;' +
                '  margin-left: -40px;">' +
                '          Oops, Something went wrong! Please continue to try again later.' +
                '          <br />' +
                "          If you still can't create the order after multiple attempts, please contact customer service." +
                '        </p>',
              okText: 'Try again',
            });
          }
        })
        .catch(error => {
          this.$Modal.error({
            content:
              '<p style="font-family: Montserrat-Regular; font-size: 16px; font-weight: 400;' +
              '  color: #262626; line-height: 25px;' +
              '  margin-left: -40px;">' +
              '          Oops, Something went wrong! Please continue to try again later.' +
              '          <br />' +
              "          If you still can't create the order after multiple attempts, please contact customer service." +
              '        </p>',
            okText: 'Try again',
          });
        })
        .finally(() => {
          this.$emit('change-loading', false);
          this.saveLoding = false;
        });
    },
    checkForm() {
      if (this.firstname.trim() === '' || this.lastname.trim() === '') {
        this.toast('Shipper name is required.');
        return false;
      }
      if (this.sendAddr1.trim() === '') {
        this.toast('Shipping address is required.');
        return false;
      }
      if (this.state.trim() === '') {
        this.toast('Province is required.');
        return false;
      }
      if (this.sendCity.trim() === '') {
        this.toast('City is required.');
        return false;
      }
      if (this.zipcode.trim() === '') {
        this.toast('Zip code required.');
        return false;
      }
      if (!this.zipcodeChecked) {
        this.toast('Zip code is invalid.');
        return false;
      }
      if (this.sendMobile.trim() === '') {
        this.toast('Phone number.');
        return false;
      }
      if (!isValidPhoneNumber(this.sendMobile, 'US')) {
        this.toast('The phone number is invalid');
        return false;
      }
      if (
        this.pickup &&
        (this.pickupDatePrefix === '' || this.selectPickupTime === '' || this.selectCutoffTime === '')
      ) {
        this.toast('please select pick up date.');
        return false;
      }

      return true;
    },
    toast(msg) {
      this.$Message.warning({
        content: msg,
        duration: 3,
      });
    },
    ...mapActions('send', [
      'getInsurance',
      'getPickUpPrice',
      'saveOrder2serverAndLocle',
      'getPickUpTimeRange',
      'getStates',
    ]),
    ...mapMutations('send', ['setOrder', 'setStoreOrder', 'updateChange', 'clearLocaleOrder']),
    setLocalOrder(key, val) {
      this.setStoreOrder({
        key,
        val,
      });
    },
  },
  filters: {
    numer(index) {
      return `#${index + 1}`;
    },
  },
  computed: {
    ...mapState('send', ['insurances', 'localeOrder', 'sendInfo', 'isChange']),
    ...mapState('calculate', ['calculate']),
    zipcodeChecked() {
      let zipreg = /^\d{5}(?:[-\s]\d{4})?$/;
      return zipreg.test(this.zipcode);
    },
    price() {
      const regex = /\$([\d.]+)/; // 匹配以$开头的数字部分
      const match = this.coverageType.match(regex);
      return match ? match[1] : 0;
    },
    charge() {
      const regex = /\$([\d.]+)/; // 匹配以$开头的数字部分
      const match = this.coverageType.match(regex);
      if (match) {
        const amount = parseFloat(match[1]);
        let a = (Number(amount) * 100 * 7 * this.boxes.length) / 100;
        return a;
      } else {
        return 0;
      }
    },
    selectDateToday() {
      if (this.pickupDatePrefix === '') {
        return true;
      }
      if (this.pickupDatePrefix) {
        let fix = new moment(this.pickupDatePrefix, 'MM/DD/YY').format('MM/DD/YYYY');
        if (this.pickupDate.indexOf(fix) === 0) {
          return true;
        }
      }
      return false;
    },
  },
  watch: {
    sendAddr1(n) {
      this.setLocalOrder('sendAddr1', n);
    },
    sendCity(n) {
      this.setLocalOrder('sendCity', n);
    },
    firstname(n) {
      this.setLocalOrder('firstname', n);
    },
    lastname(n) {
      this.setLocalOrder('lastname', n);
    },
    zipcode(n) {
      if (this.pickup) {
        this.slectPickUp(true);
      }
      this.setLocalOrder('zipcode', n);
    },
    state(n) {
      this.setLocalOrder('state', n);
    },
    sendMobile(n) {
      this.setLocalOrder('sendMobile', n);
    },
    boxes(n) {
      this.setLocalOrder('boxes', n);
    },
    orderNum(n) {
      this.setLocalOrder('orderNum', n);
    },
    pickup(n) {
      this.setLocalOrder('pickup', n);
    },
    houseId(n) {
      this.setLocalOrder('houseId', n);
    },
    sendCountry(n) {
      this.setLocalOrder('sendCountry', n);
    },
    sendAddr2(n) {
      this.setLocalOrder('sendAddr2', n);
    },
    pickupDatePrefix(n) {
      this.setLocalOrder('pickupDatePrefix', n);
    },
    selectPickupTime(n) {
      this.setLocalOrder('selectPickupTime', n);
    },
    selectCutoffTime(n) {
      this.setLocalOrder('selectCutoffTime', n);
    },
    sendInfo: {
      handler() {
        if (this.sendInfo) {
          this.processSendInfo();
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.form-title {
  .font-regular;
  font-size: 14px;
  font-weight: 400;
  color: #262626;
}
.send-sendpackge {
  position: relative;
  .title {
    .font-regular;
    font-size: 20px;
    font-weight: 400;
    color: @app-black-color;
  }
  .desc {
    .font-regular;
    font-size: 16px;
    font-weight: 400;
    color: @app-black-color;
    line-height: 20px;
    margin-top: 30px;
  }
  .form {
    .row {
      padding-top: 10px;
    }
    .shipper-name {
      width: 246px;
      &:last-child {
        margin-left: 16px;
      }
    }
    .shipping-address {
      .floor {
        margin-top: 16px;
      }
    }
    .sp-wrap {
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      gap: 16px;
      .country {
        width: 50px;
      }
      .state {
        width: 180px;
      }
      .city {
        width: 246px;
      }
      .zip-code {
        width: 246px;
      }
      .phone-number {
        width: 246px;
      }
    }
  }
  .boxes {
    margin-top: 46px;
    .boxes-title {
      .form-title;
    }
    .boxes-desc {
      .font-light;
      padding-top: 10px;
      font-size: 12px;
      font-weight: 300;
      color: @app-black-color;
      a {
        color: @app-blue-color;
        cursor: pointer;
      }
    }
    .box-list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      padding-top: 10px;
      .box-item {
        width: 240px;
        margin-top: 6px;
        .remove {
          .font-light;
          cursor: pointer;
          font-size: 12px;
          color: @app-blue-color;
        }
      }
    }
  }
  .coverage-box {
    .title {
      .font-regular;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 4px;
      color: @app-black-color;
    }
    .desc {
      .font-light;
      font-weight: 300;
      font-size: 12px;
      color: @app-black-color;
      a {
        color: @app-blue-color;
        cursor: pointer;
      }
    }
    .card {
      .font-regular;
      width: 508px;
      height: 70px;
      padding: 22px 24px;
      background: #ffffff;
      box-shadow: 0 2px 8px 0 rgba(207, 207, 207, 0.2);
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      //float: left;
      color: @app-black-color;
      line-height: 18px;
      border: 1px solid @app-placeholder-color;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      .star {
        font-size: 18px;
        position: relative;
        top: 5px;
        left: 0;
      }
      .card-right-title {
        .font-regular;
        font-weight: 400;
        font-size: 16px;
        color: @app-black-color;
      }
      .card-right-desc {
        .font-light;
        font-weight: 300;
        font-size: 13px;
        color: @app-black-color;
        margin-top: 4px;
        display: inline-block;
      }
      .card-left {
        .font-light;
        font-weight: 300;
        font-size: 14px;
      }
    }
    .dropdown-item-box {
      width: 508px;
      height: 70px;
      padding: 22px 24px;
      background: #ffffff;
      box-shadow: 0 2px 8px 0 rgba(207, 207, 207, 0.2);
      border-radius: 4px;
      border: 1px solid @app-placeholder-color;
      margin-top: 16px;
    }
    .active {
      border: 1px solid @app-color;
    }
    .download-item-list {
      margin-top: 1px;
      width: 508px;
      max-height: 200px;
      overflow-y: auto;
      position: absolute;
      background-color: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
      .download-item {
        .font-light;
        font-size: 14px;
        color: @app-black-color;
        line-height: 40px;
        height: 40px;
        padding-left: 20px;
        cursor: pointer;
      }
      .download-item:hover {
        background-color: #f3f3f3;
      }
    }
  }
  .add-boxes {
    .font-light;
    font-size: 14px;
    width: 240px;
    color: @app-color;
    margin-top: 16px;
  }
  .packge {
    padding-top: 36px;
    .title {
      .form-title;
    }
    .type-list {
      padding-top: 20px;
      overflow: hidden;
      width: 560px;
      .type-item {
        .font-regular;
        width: 508px;
        height: 70px;
        background: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(207, 207, 207, 0.2);
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        float: left;
        color: @app-black-color;
        line-height: 18px;
        border: 1px solid @app-placeholder-color;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &.active {
          border: 1px solid @app-color;
          .type-footer {
            .type-btn {
              background: @app-color;
              color: #fff;
            }
          }
        }
        .type-left {
          display: flex;
          align-items: center;
          gap: 24px;
          margin-left: 30px;
          .type-img-box {
            width: 60px;
            text-align: center;
            img {
              height: 30px;
            }
          }

          .type-title {
            .font-regular;
            font-weight: 400;
            color: @app-black-color;
            font-size: 16px;
          }
          .type-desc-left {
            .font-light;
            text-align: start;
            font-size: 14px;
            font-weight: 300;
            color: @app-black-color;
          }
        }
        .type-right {
          .type-desc {
            .font-light;
            background-color: #efeffe;
            color: @app-blue-color;
            font-size: 10px;
            height: 27px;
            line-height: 27px;
            padding: 0 10px;
            border-bottom-left-radius: 15px;
            a {
              color: @app-blue-color;
              cursor: pointer;
            }
          }
        }
      }
      .type-item + .type-item {
        margin-top: 16px;
      }
    }
    .type-pickup {
      padding-top: 36px;
      position: relative;
      .type-pickup-title {
        .form-title;
      }
      .loading-wrap {
        width: 20px;
        height: 50px;
      }
      .type-pickup-error {
        .font-light;
        font-size: 14px;
        font-weight: 300;
        padding-top: 10px;
        color: #ff7070;
      }
      .type-pickup-desc {
        .font-light;
        width: 506px;
        margin-top: 20px;
        background: rgba(91, 192, 215, 0.12);
        border-radius: 4px;
        padding: 16px 35px 16px 24px;
        font-size: 12px;
        font-weight: 300;
        color: #5bc0d7;
        display: flex;
        gap: 15px;
        align-items: center;
        img {
          width: 30px;
        }
        .date-span {
          .font-regular;
          font-weight: 500;
        }
      }
      .earliest-time {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 26px;
        .date {
          width: 160px;
        }
        .time {
          width: 147px;
          margin-left: 26px;
        }
      }
    }
  }
  .info-footer {
    margin-top: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      width: 146px;
    }
  }
}
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.5s;
}

.dropdown-enter,
.dropdown-leave-to {
  opacity: 0;
}
/deep/ .ivu-input[disabled],
fieldset[disabled] .ivu-input {
  background-color: #ffffff;
  color: @app-black-color;
  text-align: center;
}
.save-loading-dialog {
  display: flex;
  margin: 0 auto;
  height: 200px;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
  p {
    .font-regular;
    font-size: 16px;
    font-weight: 400;
    color: #262626;
    line-height: 25px;
  }

  .spin-icon-load {
    animation: ani-spin 1s linear infinite;
  }
  @keyframes ani-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
<style lang="less">
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
